module.exports = "/_next/static/images/40c772150cdfdcb9eb3647e7dbfe161c-cajitas-right-desktop.jpg.webp";